import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../assets/css/StatusPages.css";
import { Check } from "../components/Icons";

const Success = () => (
  <>
    <Helmet>
      <title>Order confirmed – Farmer Boaz</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <div className="status-page">
      <div className="status-card">
        <span className="status-badge">
          <Check />
        </span>
        <h1>Thank you — your payment was successful</h1>
        <p>
          Your order is confirmed. We will email your receipt shortly, and your delivery goes out
          within 7 business days of the campaign closing.
        </p>
        <div className="status-actions">
          <Link to="/track-order" className="btn">
            Track your order
          </Link>
          <Link to="/" className="btn btn--ghost">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default Success;
